import { IFullTheme } from "../types/theme";

interface AdsenseConfig {
  clientId: string;
  squareId?: string;
  verticalId?: string;
}

export const ADSENSE_CONFIG: AdsenseConfig = JSON.parse(
  import.meta.env.VITE_ADSENSE_CFG || "{}",
);

export const THEME_CONFIG: IFullTheme = JSON.parse(
  import.meta.env.VITE_THEME_CFG || "{}",
);
